var map = {
	"./attraversamento-pedonale-so.png": 3609,
	"./attraversamento-pedonale.png": 8101,
	"./dare-precedenza-so.png": 2427,
	"./dare-precedenza.png": 1654,
	"./diritto-precedenza-senso-unico-alternato.png": 9506,
	"./divieto-accesso.png": 1196,
	"./divieto-sorpasso-auto.png": 3375,
	"./divieto-sorpasso-autocarri.png": 5482,
	"./divieto-sosta-fermata.png": 5786,
	"./divieto-sosta.png": 4989,
	"./divieto-transito-autocarri.png": 5552,
	"./divieto-transito-limite-altezza.png": 6070,
	"./divieto-transito-limite-larghezza.png": 4239,
	"./divieto-transito-limite-peso.png": 1326,
	"./divieto-transito.png": 5921,
	"./dosso-so.png": 9123,
	"./fermata-bus-so.png": 8236,
	"./lanterna-semaforica.png": 2144,
	"./limite-vel-20.png": 2621,
	"./limite-vel-30.png": 9986,
	"./limite-vel-40.png": 3823,
	"./limite-vel-50.png": 3572,
	"./limite-vel-60.png": 4057,
	"./limite-vel-70.png": 5470,
	"./limite-vel-80.png": 4203,
	"./obbligo-dare-precedenza-senso-unico-alternato.png": 4986,
	"./obbligo-direzione-diritto-dx.png": 7019,
	"./obbligo-direzione-diritto-sx.png": 3014,
	"./obbligo-direzione-diritto.png": 4648,
	"./obbligo-direzione-dx-sx.png": 721,
	"./obbligo-direzione-dx.png": 3181,
	"./obbligo-direzione-sx.png": 2644,
	"./obbligo-passaggio-dx-sx.png": 3316,
	"./obbligo-passaggio-dx.png": 4454,
	"./obbligo-passaggio-sx.png": 7115,
	"./parcheggio-disabili-so.png": 7294,
	"./parcheggio-merci-so.png": 1313,
	"./parcheggio.png": 7119,
	"./passo-carrabile.png": 8084,
	"./pericolo-attraversamento-pedonale.png": 8335,
	"./pericolo-doppia-curva-dx.png": 456,
	"./pericolo-doppia-curva-sx.png": 3593,
	"./pericolo-doppio-senso.png": 3997,
	"./pericolo-dosso_cunetta_strada-dissestata.png": 9007,
	"./pericolo-intersezione-con-precedenza-dx-sx.png": 13,
	"./pericolo-intersezione-con-precedenza-dx.png": 4617,
	"./pericolo-intersezione-con-precedenza-sx.png": 5736,
	"./pericolo-lanterna-semaforica.png": 5414,
	"./pericolo-lavori-in-corso.png": 9660,
	"./pericolo-strada-sdrucciolevole.png": 2529,
	"./pericolo-strettoia-dx-sx.png": 2283,
	"./pericolo-strettoia-dx.png": 4138,
	"./pericolo-strettoia-sx.png": 7703,
	"./pericolo.png": 6611,
	"./rotatoria.png": 7923,
	"./senso-unico-dx.png": 9560,
	"./senso-unico-sx.png": 6969,
	"./stop-so.png": 6765,
	"./stop.png": 9860,
	"./strada-senza-sbocco.png": 2731
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3873;